import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import EventsAwardsHeader from "@events-awards/components/EventAwardsHeader";
import EventsAwardsFooter from "@events-awards/components/EventsAwardsFooter";
import EventsAwardsNavigationBar from "@events-awards/components/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import { getAwardType } from "@events-awards/utils/helpers";

import LayoutFactory from "./LayoutFactory";

type SIAStaticPageProps = {
  /** The url string to get url at SIA static page. */
  urlPath: string;
};

/**
 * component to render SIA static navigation pages
 */
const EventsAwardsStaticPageContent = ({
  urlPath,
}: SIAStaticPageProps): React.ReactElement => {
  return (
    <div
      className="w-full"
      data-testid="events-awards-static-page-content-component"
    >
      <EventsAwardsHeader />

      <Container>
        <div className="mb-8 w-full justify-center px-0 text-left text-gray-850">
          <EventsAwardsNavigationBar awardType={getAwardType(urlPath)} />

          <LayoutFactory urlPath={urlPath} />
        </div>
      </Container>

      <EventsAwardsFooter awardType={getAwardType(urlPath)} />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};
export default EventsAwardsStaticPageContent;
